import React from 'react';
import { Layout } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import { StorefrontHeader } from '../components/StorefrontHeader';
import { CartDrawer } from '../components/CartDrawer';
import { StorefrontFooterDock } from '../components/StorefrontFooterDock';
import { useStoreScheduleSync } from '../hooks/useStoreScheduleSync';

const { Content } = Layout;

export const StorefrontLayout: React.FC = () => {
  const location = useLocation();
  // Mantener isOpen/todayHours vivo (polling liviano) sin re-fetch del catálogo
  useStoreScheduleSync({ pollingIntervalMs: 2 * 60_000 });

  const isCheckoutPage = location.pathname.includes('/checkout');

  return (
    <Layout style={{ minHeight: '100dvh', backgroundColor: 'var(--color-paper)' }}>
      <StorefrontHeader />

      <Content
        style={{
          paddingBottom: isCheckoutPage ? 0 : 'calc(84px + env(safe-area-inset-bottom, 0px))',
          backgroundColor: 'var(--color-paper)',
        }}
      >
        <Outlet />
      </Content>

      <CartDrawer />
      <StorefrontFooterDock />
    </Layout>
  );
};

export default StorefrontLayout;
